import React from 'react';
import ScanView from '../../ScanView';
import Urls from '../../../enum/urls';
import { ScoreResult } from '../../../types/api';

type Props = {
  onSuccess: (result: ScoreResult) => void;
  onFail: (result: ScoreResult) => void;
  onBack: () => void;
}

const params = {
  apiId: 1,
  credentialId: 1,
  dataProviderId: 1,
};

const OntoScan: React.FC<Props> = ({ onSuccess, onFail, onBack }) => (
  <ScanView
    url={Urls.GetScoreQr}
    resultUrl={Urls.GetCommonScanResult}
    params={params}
    onSuccess={onSuccess}
    onFail={onFail}
    onBack={onBack}
  />
);

export default OntoScan;
